import { object } from 'yup'

export default object({
  favicon: object().label('Favicon').notRequired(),
  main_logo: object().label('Main logo').notRequired()
})
